<template>
  <div class="select2-wrapper" :class="{clearable: conf.clearable}">
    <!--    <div>{{ conf }}</div>-->
    <!--    <div>{{options}}</div>-->
    <!--    {{ value }}-->
    <!--    {{disabled}}-->
    <select ref="select2" class="form-select" :class="classes" :id="id" :name="name"
            :required="required"></select>
  </div>
</template>

<script>
const config = {
  id: 'id',
  label: 'name',
  searchable: true,
  clearable: true,
  raw: null,
  selectAll: false,
}

const ajaxDefaults = {
  axios: true,
  ignore: false,
  url: null,
  delay: 500,
  term: 'search',
  params: {},
  paginated: false,
  paginationHandler: (data) => data.links.next,
  resHandler: (data) => data.data,
}

export default {
  name: 'Select2',
  data() {
    return {
      select2: null,
      options_: [],
    };
  },
  model: {
    event: 'change',
    prop: 'value'
  },
  emits: [
    'change',
    'select',
    'closing',
    'close',
    'opening',
    'open',
    'clearing',
    'clear',
  ],
  props: {
    template: {
      default() {
        return (item) => `${item.text}`
      }
    },
    selectionTemplate: {
      default() {
        return (item) => this.template(item)
      }
    },
    classes: {
      default: () => ['form-select-solid', 'form-select-sm']
    },
    invalid: {
      default: false,
    },
    config: {
      type: Object,
      default: () => {
      },
    },
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Select One'
    },
    options: {
      type: Array,
      default: () => []
    },
    disabled: {
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    tags: {
      type: Boolean,
      default: false
    },
    value: null
  },
  watch: {
    invalid(){
      this.setInvalid()
    },
    options(val) {
      this.normalize()
      this.setOption();
    },
    'config.ajax.params': {
      handler(val, ovl) {
        this.setOption();
      }
    },
    disabled(val) {
      this.setDisabled()
    },
    value(val) {
      this.setValue(val);
    },
    // conf(v){
    //   this.setOption()
    // },
  },
  computed: {
    conf() {
      if (!this.config) return {...config};

      return {...config, ...this.config}
    },
    computedOpts() {
      const ajaxConfig = this.config && this.config.ajax ? {...ajaxDefaults, ...this.conf.ajax} : {...ajaxDefaults}
      const ajax = this.conf.ajax && !this.conf.ajax.ignore ?
          {
            // dropdownParent: $(this.$el).closest(".modal-body"),
            delay: ajaxConfig.delay,
            url: function (params) {
              return ajaxConfig.url
            },
            data: function (params) {
              let qParams = {...ajaxConfig.params,}
              qParams[ajaxConfig.term] = params.term
              // qParams.q = params.term
              if (ajaxConfig.paginated) {
                qParams.page = params.page || 1
              }

              return qParams;
            },
            processResults: (data) => {
              // debugger
              const formatted = ajaxConfig.resHandler(data)
              const normalizedResults = formatted.map(ele => this.normalizer(ele))

              const procPagination = () => {
                if (!ajaxConfig.paginated) return undefined

                return {
                  more: ajaxConfig.paginationHandler(data)
                }
              }
              const pagination = procPagination()

              return {
                results: normalizedResults,
                pagination,
              };
            },
            transport: (params, success, failure) => {
              // debugger
              const initial = _.get(params, 'term', null)

              // const axios_ = typeof ajaxConfig.axios === 'function' ? ajaxConfig.axios : window.axios
              axios.get(params.url, {
                params: params.data
              })
                  .then(({data}) => success(data))
                  .catch((err) => failure(err.response.data))

              return {}
            }
          }
          : null;

      if (ajax && !ajaxConfig.axios) {
        ajax.transport = undefined
      }

      const rawConfig = this.conf.raw || {}
      return {
        disabled: this.disabled,
        ajax,
        // templateSelection: this.renderSelectionTemplate,
        // templateResult: this.renderTemplate,
        escapeMarkup: (e) => e,
        placeholder: this.placeholder,
        allowClear: this.conf.clearable,
        multiple: this.conf.multiple,
        tags: this.tags,
        minimumResultsForSearch: this.conf.searchable ? undefined : Infinity,
        data: this.options_,
        dropdownParent: $(this.$el),
        dropdownAutoWidth: true,
        // width : '<value>',
        ...rawConfig,
      }
    }
  },
  methods: {
    setInvalid(){
      if (!this.select2) return

      const selection = $(this.select2).next().find('.select2-selection');
      const dump = this.invalid ? selection.addClass('is-invalid') : selection.removeClass('is-invalid')
    },
    setDisabled() {
      if (!this.select2) return
      //2 params cause disabling of the select element
      const selParams = this.disabled ? ["enable", false] : ["enable"]
      this.select2.select2(...selParams)
    },
    setOption() {
      this.select2.empty();
      this.select2.select2(this.computedOpts);
      this.setValue(this.value);
    },
    setValue(val) {
      if (val instanceof Array) {
        this.select2.val([...val]);
      } else {
        this.select2.val([val]);
      }
      this.select2.trigger('change');
    },
    pushSelectAll(){
      if(!this.conf.selectAll) return
      this.options_.unshift({id: 'selectAll', text: 'Select/Deselect All'})
    },
    normalize() {
      if (this.config?.preventTransform) {
        this.options_ = this.options
        this.pushSelectAll()
        return
      }

      this.options_ = this.options.map(ele => this.normalizer(ele))
      this.pushSelectAll()
    },
    normalizer(node) {
      return {
        raw_: {...node},
        id: node[this.conf.id],
        text: node[this.conf.label],
      }
    },
    renderTemplate(item) {
      if (!item.id) {
        return item.text;
      }
      // console.log(this.template)
      if (!this.template) return item.text

      return this.template(item)
    },
    renderSelectionTemplate(item) {
      if (!item.id) {
        return item.text;
      }
      // console.log(this.template)
      if (!this.selectionTemplate) return item.text

      return this.selectionTemplate(item)
    },

    // modify instance
    focus() {
      this.select2.select2("open")
    },
  },
  mounted() {
    const self = this
    this.normalize()
    this.select2 = $(this.$el)
        .find('select')
        .select2(this.computedOpts)
        // Handle the select/deselect all option
        .on('select2:selecting select2:unselecting', function (e) {
          if(!self.conf.multiple) return
          if(!self.conf.selectAll) return

          var $select = $(this);
          var $option = $(e.params.args.data.element);

          if ($option.val() === 'selectAll') {
            var $allOptions = $select.find('option:not(:disabled)');
            var allSelected = $allOptions.filter(':selected').length >= $allOptions.length - 1;

            const selectedArr = []
            if (allSelected) {
              self.$emit('change', []);
            }else{
              $allOptions.each(function (option) {
                if(option < 1) return
                selectedArr.push($allOptions[option].value)
              });
            }
            self.$emit('change', selectedArr);

            e.preventDefault();
            $select.select2('close')
          }
        })
        .on('select2:select select2:unselect', ev => {
          this.$emit('change', this.select2.val());
          this.$emit('select', ev['params']['data']);
        })
        .on('select2:closing', ev => {
          this.$emit('closing', ev);
        })
        .on('select2:close', ev => {
          this.$emit('close', ev);
        })
        .on('select2:opening', ev => {
          this.$emit('opening', ev);
        })
        .on('select2:open', ev => {
          this.$emit('open', ev);
        })
        .on('select2:clearing', ev => {
          this.$emit('clearing', ev);
        })
        .on('select2:clear', ev => {
          this.$emit('clear', ev);
        });
    this.setValue(this.value);
  },
  beforeDestroy() {
    this.select2.off('select2:selecting select2:unselecting select2:select select2:unselect select2:closing select2:close select2:opening select2:open select2:clearing select2:clear')
    this.select2.select2('destroy');
  },
};
</script>